import { environment as base } from "./environment.base";

export const environment = {
  ...base,
  code: 'cirt',
  dashboard: '',
  ga:'G-F8X713Z0VQ'
};
